import { FC } from "react";

import { ArchivedCampaignBannerView } from "./ArchivedCampaignBannerView";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useAmplitude } from "@/common/hooks/amplitude/useAmplitude";

/**
 * Container that wires FormV2 context and analytics to ArchivedCampaignBannerView.
 */
export const ArchivedCampaignBanner: FC = () => {
  const { logAmplitudeEvent } = useAmplitude();
  const { formObject, publishedOrgPageUrl, formOrganization } = useFormV2Context();

  const organizationName = formOrganization.name;
  const logoUrl = formObject.logoUrl ?? (formOrganization as { logoUrl?: string | null }).logoUrl ?? null;

  return (
    <ArchivedCampaignBannerView
      organizationName={organizationName}
      logoUrl={logoUrl}
      publishedOrgPageUrl={publishedOrgPageUrl}
      onOrgPageOpen={() => logAmplitudeEvent(AmplitudeEvents.OrgPageOpened, { from: "banner" })}
    />
  );
};
